import { useEffect, useState } from "react";

import Headline from "~/components/Headline/Headline";
import Hint from "~/components/Hint";
import Modal from "~/components/Modal";
import SidebarBusyOverlay from "~/components/Sidebar/components/SidebarBusyOverlay";
import type {
	StaffingUnlock,
	UpdateStaffingUnlocksPayload,
} from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import { StaffingUnlockForm } from "~/modules/billing/components/InvoiceDetailsView/components/StaffingUnlockForm.tsx";

type Props = {
	onClose: () => void;
	/** Returns an error message, or `null` when the unlock worked. */
	onSubmit: (payloads: UpdateStaffingUnlocksPayload[]) => Promise<string | null>;
	open: boolean;
	staffingUnlocks: StaffingUnlock[];
};

export function StaffingUnlockModal(props: Props) {
	const [busy, setBusy] = useState(false);
	const [error, setError] = useState("");

	useEffect(() => {
		if (props.open) setError("");
	}, [props.open]);

	const handleSubmit = async (payloads: UpdateStaffingUnlocksPayload[]) => {
		setBusy(true);
		const message = await props.onSubmit(payloads);
		setBusy(false);
		if (message) {
			setError(message);
			return;
		}
		props.onClose();
	};

	return (
		<Modal open={props.open}
			   setOpen={props.onClose}>
			<div className="relative flex flex-col gap-3">
				{busy && <SidebarBusyOverlay />}
				<Headline type="h4">Erfassungen entsperren</Headline>
				<p className="text-sm leading-relaxed text-gray-600">
					Wähle die Staffings dieser Rechnung, deren Erfassungen temporär entsperrt werden.
				</p>
				{error && <Hint theme="error">{error}</Hint>}
				<StaffingUnlockForm busy={busy}
									staffingUnlocks={props.staffingUnlocks}
									submitLabel={(selectedCount, totalCount) => totalCount > 2
										? `${selectedCount} von ${totalCount} Staffings entsperren`
										: "Staffing entsperren"}
									onCancel={props.onClose}
									onSubmit={handleSubmit} />
			</div>
		</Modal>
	);
}
